import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=3f8d5d21&"
import script from "./tasks.vue?vue&type=script&lang=ts&"
export * from "./tasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports